// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import PeopleIcon from '@mui/icons-material/People';
import moment from 'moment';

// Read-only list of users (from mobile signup). View opens the user info page.
const UsersTable: React.FC = () => {
  return (
    <EntityTable
      pageTitle="Users"
      pageIcon={PeopleIcon}

      viewPageUrl="/CardsManagement/users/:id"

      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/users`}
      getApiMethod="GET"
      responseDataPath="data.data.users"
      responsePaginationPath="data.data.pagination"

      idField="id"
      columns={[
        { field: 'name', headerKey: 'Name', align: 'center', sortable: true, sortField: 'u.name', render: (v, row) => row.name || '-' },
        { field: 'phone', headerKey: 'Phone', align: 'center', sortable: true, sortField: 'u.phone' },
        { field: 'email', headerKey: 'Email', align: 'center', render: (v, row) => row.email || '-' },
        { field: 'passengers_group_name', headerKey: 'GroupName', align: 'center', render: (v, row) => row.passengers_group_name || '-' },
        { field: 'created_at', headerKey: 'CreatedAt', align: 'center', sortable: true, sortField: 'u.created_at', render: (v) => v ? moment(v).format('DD/MM/YYYY HH:mm:ss') : '-' },
      ]}

      searchQueryParam="search"
      searchPlaceholder="SearchUserPlaceholder"
      searchInputWidth="280px"

      // ============ PERMISSIONS (Cards Management family) ============
      subsystemName="Users"
      permissionSystem="masterConfig"

      // ============ READ-ONLY: no add / edit / delete (users come from mobile) ==
      showAddButton={false}
      showActions={true}
      showEdit={false}
      showDelete={false}
    />
  );
};

export default UsersTable;
